import { gql } from '@apollo/client'

export const DELETE_PAYMENT_METHOD = gql`
    mutation b2c_delete_payment_method($payment_method_id: String!) {
        b2c_delete_payment_method(payment_method_id: $payment_method_id) {
            success
        }
    }
`
